import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = {
    key: 1,
    class: "text-gray-400"
};
import { clsx } from 'clsx';
import moment from 'moment';
import { I18nInfo } from '@/user/models';
import { examLabel } from '@/user/models/certification/monthly-exam';
const baseTd = 'border-t border-r border-gray-200 px-16 py-20 text-body-3 text-gray-700 last:border-r-0';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ExamDetailTable',
    props: {
        exams: {}
    },
    emits: ["apply"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const t = new I18nInfo('certification.testApply');
        const styles = {
            wrapper: clsx('my-72 overflow-hidden rounded-12 border border-gray-200'),
            table: clsx('w-full text-center text-gray-800'),
            thead: clsx('bg-gray-150 text-body-2 text-gray-900'),
            th: clsx('px-16 py-18 font-medium border-r border-gray-200 last:border-r-0'),
            td: clsx(baseTd),
            titleTd: clsx(baseTd, 'font-medium'),
        };
        const formatDate = (startAt) => {
            return moment(startAt).format('YYYY.MM.DD HH:mm');
        };
        const formatTime = (examTime) => {
            return examTime ? `${examTime}${t.translate('modal.timeUnit')}` : '-';
        };
        const getMethodLabel = (method = '') => {
            return method === 'ONLINE' ? t.translate('methodOnline') : t.translate('methodOffline');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(styles.wrapper)
            }, [
                _createElementVNode("table", {
                    class: _normalizeClass(styles.table)
                }, [
                    _createElementVNode("thead", null, [
                        _createElementVNode("tr", {
                            class: _normalizeClass(styles.thead)
                        }, [
                            _createElementVNode("th", {
                                class: _normalizeClass(styles.th),
                                style: { "width": "22%" }
                            }, _toDisplayString(_unref(t).translate('section7.col1')), 3),
                            _createElementVNode("th", {
                                class: _normalizeClass(styles.th),
                                style: { "width": "12%" }
                            }, _toDisplayString(_unref(t).translate('section7.col2')), 3),
                            _createElementVNode("th", {
                                class: _normalizeClass(styles.th),
                                style: { "width": "16%" }
                            }, _toDisplayString(_unref(t).translate('section7.col3')), 3),
                            _createElementVNode("th", {
                                class: _normalizeClass(styles.th),
                                style: { "width": "10%" }
                            }, _toDisplayString(_unref(t).translate('section7.col4')), 3),
                            _createElementVNode("th", {
                                class: _normalizeClass(styles.th),
                                style: { "width": "12%" }
                            }, _toDisplayString(_unref(t).translate('section7.col5')), 3),
                            _createElementVNode("th", {
                                class: _normalizeClass(styles.th),
                                style: { "width": "14%" }
                            }, _toDisplayString(_unref(t).translate('section7.col6')), 3),
                            _createElementVNode("th", {
                                class: _normalizeClass(styles.th),
                                style: { "width": "14%" }
                            }, _toDisplayString(_unref(t).translate('section7.col7')), 3)
                        ], 2)
                    ]),
                    _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.exams, (exam) => {
                            return (_openBlock(), _createElementBlock("tr", {
                                key: exam.id
                            }, [
                                _createElementVNode("td", {
                                    class: _normalizeClass(styles.titleTd)
                                }, _toDisplayString(exam.title), 3),
                                _createElementVNode("td", {
                                    class: _normalizeClass(styles.td)
                                }, _toDisplayString(_unref(examLabel).level(exam)), 3),
                                _createElementVNode("td", {
                                    class: _normalizeClass(styles.td)
                                }, _toDisplayString(formatDate(exam.startAt)), 3),
                                _createElementVNode("td", {
                                    class: _normalizeClass(styles.td)
                                }, _toDisplayString(formatTime(exam.examTime)), 3),
                                _createElementVNode("td", {
                                    class: _normalizeClass(styles.td)
                                }, _toDisplayString(getMethodLabel(exam.method)), 3),
                                _createElementVNode("td", {
                                    class: _normalizeClass(styles.td)
                                }, _toDisplayString(_unref(examLabel).state(exam)), 3),
                                _createElementVNode("td", {
                                    class: _normalizeClass(styles.td)
                                }, [
                                    (exam.applyState === 'AVAILABLE')
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            class: "cursor-pointer text-blue-600",
                                            onClick: ($event) => (emit('apply', exam))
                                        }, _toDisplayString(_unref(examLabel).apply(exam)), 9, _hoisted_1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(examLabel).apply(exam)), 1))
                                ], 2)
                            ]));
                        }), 128))
                    ])
                ], 2)
            ], 2));
        };
    }
});
